import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="project-description">
      <div className="project-title">
        <h1>vivi TIRRENIA</h1><span>in centro</span>
      </div>
      <div className="project-text">
        <h2>L'Estate si Anima!</h2>
        Cosa vi aspetta:
        <ul>
          <li>Una suggestiva area pedonale dall'Albergo Vittoria al Bagno Mary</li>
          <li>L'atmosfera unica del litorale pisano in una calda serata estiva</li>
        </ul>

        <strong>Quando</strong>: Tutti i venerdì fino al 23 agosto<br />
        <strong>Dove</strong>: Piazza pedonale nel centro di Tirrenia, direzione Pisa<br />
        <strong>Facile da raggiungere con ampi parcheggi nelle vicinanze.</strong><br />
        <strong>Consultate la mappa per i dettagli sulla viabilità.</strong>

        <img src={`${process.env.PUBLIC_URL}/images/mappaTirrenia.jpg`} alt="mappa chiusura pedonale" className="project-map"/>

        <div className="friday-event-text">
          <h3>Vedi <Link to="/event">il calendario degli eventi</Link> del <strong>16 Agosto</strong></h3>
        </div>


        <p><small>Un'iniziativa di Vivi Tirrenia aps, in collaborazione con Marenia e il Comune di Pisa, per rendere indimenticabile la vostra estate sul litorale.<br />
        Venite a scoprire il cuore pulsante di Tirrenia - vi aspettiamo per celebrare insieme le notti d'estate!</small></p>
      
        <h3>Non perdere nemmeno un evento! <a href="https://www.litoralepisano.app" target="_blank">Scarica l'App del Litorale Pisano</a> per il calendario completo.</h3>

      </div>
    </div>
  );
}

export default Home;